import React, { useContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useLocation, useNavigate } from "react-router";
// import TextEditer from "../material/textEditor/TextEditor";
import TinyMCE from "../../../material/tinymce/TinyMCE";
import UploadImage from "../../../material/uploadImage/UploadImage";
import UploadImageMultiple from "../../../material/uploadImage/UploadImageMultiple";
// import Draft from "../material/texteditorDraft/Draft";
import Datepicker from "../../../material/datepicker/Datepicker";
import ToggleCheckbox from "../../../material/toggleCheckbox/ToggleCheckbox";
import { RedirectCode400 } from "../../../RedirectCode400";
import { CurrentUserContext } from "../../../../App";
import PageHeaderV2 from "../../../pageheaderV2/PageHeaderV2";
import Select from "../../../material/select/SelectV2";
import InputV2 from "../../../material/input/InputV2";
import * as adminApi from "../../../../service/adminApi";

function AddPressRelease() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState(location.state?.category ?? "");
  const [titlepage, setTitlePage] = useState("");
  const [titleValue, setTitleValue] = useState("");
  const [detailValue, setDetailValue] = useState(location.state?.detail ?? "");
  const [publishStartDate, setPublishStartDate] = useState(
    location.state?.publishStartDate ?? "",
  );
  const [publishEndDate, setPublishEndDate] = useState(
    location.state?.publishEndDate ?? "",
  );
  const [active, setActive] = useState(location.state?.active ?? true);
  const [pined, setPined] = useState(location.state?.pined ?? false);
  const [title, setTitle] = useState(location.state?.title ?? "");
  const [weight, setWeight] = useState(location.state?.weight ?? "");
  const [imageValue, setImageValue] = useState(location.state?.image ?? "");
  const [fileValue, setFileValue] = useState(location.state?.file ?? "");
  const [defaultOption, setDefaultOption] = useState("");
  const [multipleImage, setMultipleImage] = useState(location.state?.illustration ?? []);

  useEffect(() => {
    if (location.state?.type === "announcement") {
      setTitlePage("เพิ่มข่าวประกาศ");
      setTitleValue(location.state?.type);
      setDetailValue(location.state?.detail);
      setDefaultOption("1");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      navigate("/");
    }
  }, []);

  const addContent = async () => {
    setLoading(true);
    let res = await adminApi.addContent(
      titleValue,
      imageValue,
      multipleImage,
      category,
      title,
      detailValue,
      fileValue,
      pined,
      active,
      publishStartDate,
      publishEndDate,
      weight,
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/press-release");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        // console.log(res["data"]["message_th"] || res["data"]["message"]);
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateContent = async () => {
    setLoading(true);
    let res = await adminApi.updateContent(
      location.state?.id,
      titleValue,
      imageValue,
      multipleImage,
      category,
      title,
      detailValue,
      fileValue,
      pined,
      active,
      publishStartDate,
      publishEndDate,
      weight,
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/press-release");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        // console.log(res["data"]["message_th"] || res["data"]["message"]);
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const onClickAddSubmit = (type) => {
    // console.log(imageValue);
    if (!titleValue) {
      setIsMessage({ type: "warning", data: "กรุณากรอกหัวข้อ" });
    } else if (!title) {
      setIsMessage({ type: "warning", data: "กรุณากรอกหัวข้อ" });
    } else if (!detailValue) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรายละเอียด" });
    } else if (!publishStartDate) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวันที่เผยแพร่" });
    } else {
      if (type === "announcement") {
        location.state?.detail ? updateContent() : addContent();
      }
    }
  };

  const typeList = [
    { name: "ข่าวประชาสัมพันธ์", value: "news" },
    { name: "บทความ", value: "article" },
    { name: "ประกาศ", value: "announcement" },
    { name: "คู่มือ", value: "manual" },
  ];

  return (
    <div className="min-w-[376px] overflow-x-auto">
      <PageHeaderV2
        titlename={location.state?.title ? "แก้ไขข่าวประกาศ" : titlepage}
      />

      <div className="flex flex-row justify-center items-start md:flex-col w-full gap-[20px]">
        <div className="rounded-[6px] border-[#E2E2E4] border p-[9px_16px]">
          <div className="md:text-[14px] text-[16px] text-[#000000] md:mt-1 mt-3 font-['Prompt']">
            ไฟล์รูป
          </div>
          <div className="rounded-[6px] border-[#E2E2E4] border w-full p-[9px_16px] mb-[10px]">
            <UploadImage
              title={"รองรับไฟล์ภาพที่มีนามสกุลไฟล์ .Png, Jpeg, Jpg"}
              value={imageValue}
              type={"image"}
              setValue={setImageValue}
              api={adminApi.uploadImageContent}
            />
          </div>
          <div className="flex flex-col text-[16px] font-['Prompt'] mb-[10px]">
            หมวดหมู่
            <Select
              placeholder="เลือกหมวดหมู่"
              value={category}
              setValue={(value) => setCategory(value)}
              list={typeList}
            />
          </div>
          <div className="flex flex-col text-[16px] font-['Prompt'] mb-[10px]">
            หัวข้อ
            <InputV2
              type="text"
              className="border-1 border-solid border-[#E0DFE2] rounded-lg md:text-[14px] text-[#000000] p-2 focus:outline-none md:mt-0 md:mb-0 mt-1 mb-4 w-full h-[38px]"
              placeholder=""
              value={title}
              onChangeEvt={(value) => setTitle(value)}
            />
          </div>
          <div>
            <div className="md:text-[14px] text-[16px] text-[#000000] md:mt-1 mt-3 font-['Prompt']">
              รายละเอียด
            </div>
            <TinyMCE
              readOnly={false}
              value={detailValue}
              setValue={setDetailValue}
            />
          </div>
          <div className="flex flex-col text-[16px] font-['Prompt'] md:mt-1 mt-3 mb-[10px]">
            รูปประกอบ
            <div className="rounded-[6px] border-[#E2E2E4] border w-full p-[9px_16px] mb-[10px]">
                <UploadImageMultiple
                  type="image"
                  title="รองรับรูปภาพนามสกุล PNG, JPG ขนาดไม่เกิน 5MB"
                  value={multipleImage}     
                  setValue={setMultipleImage}
                  api={adminApi.uploadImageContent}
                  limit={5}
                />

                {/* <div className="mt-5">
                  <p>จำนวนไฟล์ที่อัปโหลดแล้ว: {multipleImage.length} ไฟล์</p>
                </div> */}
            </div>
          </div>
          <div>
            <div className="md:text-[14px] text-[16px] text-[#000000] md:mt-1 mt-3 font-['Prompt']">
              ไฟล์แนบ
            </div>
            <div className="rounded-[6px] border-[#E2E2E4] border w-full p-[9px_16px] mb-[10px]">
              <UploadImage
                title={"รองรับไฟล์ที่มีนามสกุลไฟล์ PDF"}
                value={fileValue}
                type={"file"}
                setValue={setFileValue}
                api={adminApi.uploadFileContent}
              />
            </div>
          </div>
        </div>
        <div>
          <div className="rounded-[6px] border-[#E2E2E4] border p-[9px_16px]">
            {/* <div className="flex flex-col gap-[8px] font-['Prompt'] text-[16px] mb-[10px]">
              ปักหมุด
              <ToggleCheckbox label="" value={pined} setValue={setPined} />
            </div> */}

            <div className="flex flex-col mt-4 font-['Prompt'] text-[16px] mb-[10px]">
              ลำดับ
              <InputV2
                type="text"
                className="border-1 border-solid border-[#E0DFE2] rounded-lg md:text-[14px] text-[#000000] p-2 focus:outline-none md:mt-0 md:mb-0 mt-1 mb-4 w-full h-[38px]"
                placeholder=""
                value={weight}
                onChangeEvt={(value) => setWeight(value)}
              />
            </div>

            <div className="flex flex-col mt-4 font-['Prompt'] text-[16px] mb-[10px]">
              วันที่เเสดง
              <Datepicker
                label=""
                value={publishStartDate}
                setValue={setPublishStartDate}
                className="md:text-[14px] text-xl text-[#000000] font-['Prompt'] text-[16px]"
                title="publicity"
              ></Datepicker>
            </div>
            <div className="flex flex-col mt-4 font-['Prompt'] text-[16px] mb-[10px]">
              วันที่หมดอายุ
              <Datepicker
                label=""
                value={publishEndDate}
                setValue={setPublishEndDate}
                className="md:text-[14px] text-xl text-[#000000] font-['Prompt'] text-[16px]"
                title="publicity"
              ></Datepicker>
            </div>
            <div className="flex flex-col gap-[8px] mt-4 font-['Prompt'] text-[16px] mb-[10px]">
              สถานะที่เผยเเพร่
              <ToggleCheckbox label="" value={active} setValue={setActive} />
            </div>
          </div>
          <div className="flex flex-row gap-3 justify-end items-center mt-[10px] md:justify-center">
            <button
              onClick={() => {
                navigate("/admin/management/laboratory-inspection-guideline");
              }}
              className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#C0C0C0] rounded-[5px] gap-1 text-[#FFFFFF] "
            >
              ยกเลิก
            </button>
            <button
              onClick={() => {
                onClickAddSubmit(location.state?.type);
              }}
              className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#2EA669] rounded-[5px] gap-1 text-[#FFFFFF] "
            >
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddPressRelease;
